var _path, _path2, _circle, _path3, _circle2, _path4, _circle3, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _line, _line2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSpam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 66.5 66.5",
    viewBox: "0 0 66.5 66.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1FA6F8",
    d: "M11.2,18.8l1.8-5.6l-6.1,0.2l1,1.4c0,0-7.2,6.9-0.3,13.4c0,0-3.1-5.8,2.5-10.7L11.2,18.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9889",
    d: "M56.4,22.1l3.1,5l3.8-4.8l-1.8-0.2c0,0-0.6-10-10-9c0,0,6.4,1.4,6.6,8.8L56.4,22.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4,
    cy: 50.5,
    r: 3.9,
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCD6EF",
    d: "M2.4,65.2v-2.4C2.4,59.6,5,57,8.2,57h0.1l2,2.7l2-2.7h0c3.2,0,5.8,2.6,5.8,5.8v2.4H2.4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.1,
    cy: 50.5,
    r: 3.9,
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0FCAAD",
    d: "M26,65.2v-2.4c0-3.2,2.6-5.8,5.8-5.8h0.1l2,2.7l2-2.7h0c3.2,0,5.8,2.6,5.8,5.8v2.4H26z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7,
    cy: 50.5,
    r: 3.9,
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9889",
    d: "M49.7,65.2v-2.4c0-3.2,2.6-5.8,5.8-5.8h0.1l2,2.7l2-2.7h0c3.2,0,5.8,2.6,5.8,5.8v2.4H49.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 6,
    x: 24.1,
    y: 5.8,
    fill: "#1FA6F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 1,
    x: 23.1,
    y: 30.6,
    fill: "#BCD6EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 1,
    x: 23.1,
    y: 26.4,
    fill: "#BCD6EF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 1,
    x: 23.1,
    y: 22.2,
    fill: "#BCD6EF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 1,
    x: 23.1,
    y: 18,
    fill: "#BCD6EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 1,
    x: 23.1,
    y: 13.8,
    fill: "#BCD6EF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.4,
    height: 4.4,
    x: 8.3,
    y: 39.6,
    fill: "#BCD6EF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.4,
    height: 4.4,
    x: 54.5,
    y: 38.3,
    fill: "#FFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 8.7,
    height: 4.2,
    x: 28.7,
    y: 38.4,
    fill: "#FFF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 4.4,
    height: 4.4,
    x: 55.6,
    y: 39.6,
    fill: "#BCD6EF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 8.7,
    height: 4.2,
    x: 29.8,
    y: 39.7,
    fill: "#BCD6EF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33.1,
    x2: 33.1,
    y1: 46.7,
    y2: 42.6,
    fill: "#FFF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33.1,
    x2: 33.1,
    y1: 38.3,
    y2: 34.5,
    fill: "#FFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#222F59",
    d: "M8.6 29.6l-1.5-2.7c0-.1-2.7-5.2 2-9.8l1.4 1.5 2.3-7.1L5 11.7l1.3 1.9c-.8.9-3.2 3.8-3.1 7.3C3.2 25.7 7.4 28.2 8.6 29.6zM6.9 12.7l4.4-.2L10 16.6l-.9-1C9 15.8 4.4 19 5.5 24.9c-.8-1.3-1.3-2.6-1.3-4 0-2.7 1.5-5.4 3.4-7.2L6.9 12.7zM11.4 55.7c-.2 0-.3.1-.4.2l-1.6 2.2-1.6-2.2c-.1-.1-.3-.2-.5-.2-3.5 0-6.3 2.8-6.3 6.3v3.2c0 .3.2.5.5.5h15.8c.3 0 .5-.2.5-.5v-3.2C17.8 58.6 15 55.7 11.4 55.7zM16.8 64.8H2v-2.7c0-2.8 2.3-5.2 5.1-5.3L9 59.3c.1.1.2.2.4.2s.3-.1.4-.2l1.9-2.5c2.8.1 5.1 2.4 5.1 5.3V64.8zM35.1 55.7c-.2 0-.3.1-.4.2l-1.6 2.2-1.6-2.2c-.1-.1-.3-.2-.5-.2-3.5 0-6.3 2.8-6.3 6.3v3.2c0 .3.2.5.5.5H41c.3 0 .5-.2.5-.5v-3.2C41.5 58.6 38.6 55.7 35.1 55.7zM40.5 64.8H25.7v-2.7c0-2.8 2.3-5.2 5.1-5.3l1.9 2.5c.1.1.2.2.4.2s.3-.1.4-.2l1.9-2.5c2.8.1 5.1 2.4 5.1 5.3V64.8zM58.8 55.7c-.2 0-.3.1-.4.2l-1.6 2.2-1.6-2.2c-.1-.1-.3-.2-.5-.2-3.5 0-6.3 2.8-6.3 6.3v3.2c0 .3.2.5.5.5h15.8c.3 0 .5-.2.5-.5v-3.2C65.1 58.6 62.3 55.7 58.8 55.7zM64.1 64.8H49.3v-2.7c0-2.8 2.3-5.2 5.1-5.3l1.9 2.5c.1.1.2.2.4.2s.3-.1.4-.2l1.9-2.5c2.8.1 5.1 2.4 5.1 5.3V64.8zM22.6 11.1h15v-7h-15V11.1zM23.6 5.2h13v5h-13V5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222F59",
    d: "M32.6,37.9h-4.3V40H12.1v-2.2H6.7v5.4h2.2v3C6.7,46.5,5,48.3,5,50.5c0,2.4,2,4.4,4.4,4.4 c2.4,0,4.4-2,4.4-4.4c0-2.2-1.7-4.1-3.9-4.3v-3h2.2V41h16.1v2.1h4.3v3.1c-2.2,0.3-3.9,2.1-3.9,4.3c0,2.4,2,4.4,4.4,4.4 c2.4,0,4.4-2,4.4-4.4c0-2.2-1.7-4.1-3.9-4.3v-3.1h4.3V41H54v2.2h2.2v3c-2.2,0.3-3.9,2.1-3.9,4.3c0,2.4,2,4.4,4.4,4.4 c2.4,0,4.4-2,4.4-4.4c0-2.2-1.7-4.1-3.9-4.3v-3h2.2v-5.4H54V40H37.9v-2.1h-4.3V35h14.2V11.8l2.6,0.6c0.2,0.1,5.8,1.3,6.2,7.9 l-2,0.1l3.9,6.3l4.8-6.1L61,20.4C59.4,8.2,48.3,12,47.8,11.7V7.2l-6.5-6.5H19.2V35h13.4V37.9z M12.8,50.5c0,1.9-1.5,3.4-3.4,3.4 c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4C11.3,47.2,12.8,48.7,12.8,50.5z M11.1,42.2H7.7v-3.4h3.4V42.2z M36.4,50.5 c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4C34.9,47.2,36.4,48.7,36.4,50.5z M60.1,50.5 c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4C58.6,47.2,60.1,48.7,60.1,50.5z M55,38.8h3.4v3.4H55V38.8z  M36.9,42.1h-7.7v-3.2h7.7V42.1z M60.1,21.3l1.3,0.1l-2.8,3.5l-2.3-3.7l1.3,0c-0.1-0.2,0.5-5.8-4.6-8.8 C57.5,12.9,59.7,16.8,60.1,21.3z M41.6,2.4l4.5,4.5h-4.5V2.4z M20.2,1.7h20.4v6.2h6.2V34H20.2V1.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSpam);
export default __webpack_public_path__ + "static/media/no-spam.61eb0eee23eb8b536a5d484930273207.svg";
export { ForwardRef as ReactComponent };